var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcCheckmark = function SvgIcCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    fill: "none",
    viewBox: "0 0 29 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.814 5.861c.582.404.728 1.203.324 1.786l-10.28 14.848a1.575 1.575 0 0 1-2.513.1L5.34 16.48a1.283 1.283 0 0 1 1.986-1.625l4.172 5.098 9.53-13.766a1.283 1.283 0 0 1 1.786-.325",
    clipRule: "evenodd"
  })));
};
export default SvgIcCheckmark;